module.exports = __webpack_public_path__ + "DINNextLTPro-BoldItalic.ttf?b162ca1c1251f2bfb30af13c29ed050e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldItalic.ttf
// module id = 1384
// module chunks = 0